import { union } from 'es-toolkit';

import { AsyncThunkConfigWithRejectValue, createAsyncThunk } from '@/redux/createAsyncThunk';
import { getDeployment } from '@/redux/modules/config';
import { whichSellerCatalogCountsNeeded } from '@/redux/modules/seller/catalogCounts/sellerCatalogCounts.selectors';
import { getSellers, getSellersByIds } from '@/redux/modules/seller/seller.api';
import { shouldFetchSellers, whichSellersNeeded } from '@/redux/modules/seller/seller.selectors';
import { SellerResponseData } from '@/redux/modules/seller/seller.types';
import { Seller } from '@/types/Seller';

export const fetchAllSellers = createAsyncThunk<Seller[], void>(
    'la/ui/seller/fetchAllSellers',
    async (_, { getState }) => {
        const state = getState();
        const deployment = getDeployment(state);

        const response = await getSellers({ deployment });
        return response.data;
    },
    {
        condition: (_, { getState }) => shouldFetchSellers(getState()),
    }
);

export const fetchSellersByIds = createAsyncThunk<SellerResponseData, number[], AsyncThunkConfigWithRejectValue>(
    'la/ui/seller/fetchSellersByIds',
    async (sellerIds, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const deployment = getDeployment(state);

            const response = await getSellersByIds({
                deployment,
                sellerIds,
            });

            return response.data;
        } catch (error) {
            const publishedError = typeof error === 'string' ? new Error(error) : (error as Error);
            return rejectWithValue(publishedError);
        }
    }
);

export const fetchSellersByIdsIfNeeded = createAsyncThunk<void, number[]>(
    'la/ui/seller/fetchSellersByIdsIfNeeded',
    async (sellerIds, { dispatch, getState }) => {
        const neededSellers = whichSellersNeeded(getState(), sellerIds);
        const neededCatalogCounts = whichSellerCatalogCountsNeeded(getState(), sellerIds);
        const needed = union(neededSellers, neededCatalogCounts);

        if (needed.length) {
            await dispatch(fetchSellersByIds(needed));
        }
    }
);
